// Bibliotecas do framework
import React from "react";
import { useHistory } from "react-router-dom";

// Estilização
import "./style.css";

// Barra superior
import Header from "../Header";

// Logos
import gpl from "../../assets/gpl-logo.svg";
import bysa from "../../assets/by-sa.svg";

export default function Home() {
    // Define a navegação
    const nav = useHistory();

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">
                    <h3>Novidades Priore</h3>

                    <p>Seja bem-vindo(a) ao Priore. Aqui você encotrará conteúdo teórico, ferramentas de cálculo, experimentos práticos e várias outras coisas (a gosto do desenvolvedor) sobre química e engenharia. Utilize o menu no canto esquerdo para navegar pelas opções disponíveis.</p>

                    <p>PS.: Todos os textos estão sob a licença livre Creative Commons By-Sa, enquanto todos os códigos recebem a licença GPL. Em outras palavras, tudo é livre para ser utilizado, compartilhado e aprimorado.</p>

                    <div className="linha-licenca">
                        <img className="logo-licenca" src={gpl} alt="Licença GPL"/>
                        <img className="logo-licenca" src={bysa} alt="Licença Creative Commons"/>
                    </div>
                </div>
            </div>

        </div>
    );
}